import { render, staticRenderFns } from "./LegalDocumen.vue?vue&type=template&id=194d5573&scoped=true"
import script from "./LegalDocumen.vue?vue&type=script&lang=js"
export * from "./LegalDocumen.vue?vue&type=script&lang=js"
import style0 from "./LegalDocumen.vue?vue&type=style&index=0&id=194d5573&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "194d5573",
  null
  
)

export default component.exports